// # Mentee Stats Component for Step 2
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaChartLine, FaChartBar, FaChartPie } from 'react-icons/fa'; // # Import React icons
import SharedHeader from '../../../components/SharedHeader';
import DashboardFooter from '../../../components/DashboardFooter';
import UnderConstruction from '../../../components/UnderConstruction';
import './mentee_stats2.css';

// # Stats component for Step 2 mentees
function MenteeStats2({ isAdmin }) {
  const navigate = useNavigate();
  const basePath = isAdmin ? '/admin/mentorship' : '/mentorship';
  
  return (
    <div className="m_stts2_container">
      {/* # Include shared header component */}
      <SharedHeader />
      
      <div className="m_stts2_content">
        {/* # Display under construction message with icon */}
        <div className="m_stts2_icon_container">
          <FaChartLine className="m_stts2_icon" />
        </div>
        <UnderConstruction pageName="Stats Dashboard" />
      </div>
      
      {/* # Include dashboard footer */}
      <DashboardFooter />
    </div>
  );
}

export default MenteeStats2;
